import { StrokeSample } from '../rowingArcTypes';

const SAMPLE_STROKE_COUNT = 210;
const STROKE_DURATION_MS = (6 * 60 * 1000) / SAMPLE_STROKE_COUNT;

const createStrokeSeries = () => {
  const strokes: StrokeSample[] = [];

  for (let index = 0; index < SAMPLE_STROKE_COUNT; index += 1) {
    const strokeNumber = index + 1;
    const normalized = strokeNumber / SAMPLE_STROKE_COUNT;
    const catchWave = Math.sin(normalized * Math.PI * 6);
    const finishWave = Math.sin(normalized * Math.PI * 4 + Math.PI / 3);
    const slipOscillation = Math.sin(normalized * Math.PI * 12 + 0.4);
    const slipSecondary = Math.cos(normalized * Math.PI * 8 + 0.2);

    const catchAngleDeg = 58 + catchWave * 1.3;
    const finishAngleDeg = 32 + finishWave * 1.1;

    const baseCatchSlip = 8.5 + catchWave * 1.0 + slipOscillation * 0.6;
    const catchSlipDeg = Math.max(6, Math.min(14, baseCatchSlip));

    const baseFinishSlip = 5 + finishWave * 0.6 + slipSecondary * 0.4;
    const finishSlipDeg = Math.max(4, Math.min(9, baseFinishSlip));

    const driveRatio = 0.45 + Math.sin(normalized * Math.PI * 4) * 0.02;
    const driveTime = STROKE_DURATION_MS * driveRatio;
    const recoveryTime = STROKE_DURATION_MS - driveTime;

    strokes.push({
      strokeId: `sample-${strokeNumber}`,
      label: `Stroke ${strokeNumber}`,
      catchAngleDeg: Number(catchAngleDeg.toFixed(2)),
      finishAngleDeg: Number(finishAngleDeg.toFixed(2)),
      catchSlipApplicable: true,
      catchSlipConfidence: 'high',
      catchSlipDeg: Number(catchSlipDeg.toFixed(2)),
      finishSlipDeg: Number(finishSlipDeg.toFixed(2)),
      driveStartMs: Number((driveTime * 0.12).toFixed(1)),
      driveTimeMs: Number(driveTime.toFixed(1)),
      recoveryTimeMs: Number(recoveryTime.toFixed(1)),
      dataSource: 'sample',
      confidence: 0.9,
      strokeIndex: index,
      rowerPosition: 5,
    });
  }

  return strokes;
};

export const SAMPLE_ARC_STROKES: StrokeSample[] = createStrokeSeries();

export interface ArcTrendPoint {
  stroke: number;
  catchSlipDeg: number;
  finishSlipDeg: number;
  effectiveLengthDeg: number;
  forceKgf: number;
}

export const SAMPLE_TREND_POINTS: ArcTrendPoint[] = SAMPLE_ARC_STROKES.map((stroke) => ({
  stroke: stroke.strokeIndex + 1,
  catchSlipDeg: stroke.catchSlipDeg,
  finishSlipDeg: stroke.finishSlipDeg,
  effectiveLengthDeg:
    stroke.catchAngleDeg + stroke.finishAngleDeg - (stroke.catchSlipDeg + stroke.finishSlipDeg),
  forceKgf: Math.max(
    0,
    Math.min(
      180,
      112 +
        Math.sin((stroke.strokeIndex / SAMPLE_STROKE_COUNT) * Math.PI * 6) * 18 +
        Math.cos((stroke.strokeIndex / SAMPLE_STROKE_COUNT) * Math.PI * 2) * 12 +
        Math.sin((stroke.strokeIndex / SAMPLE_STROKE_COUNT) * Math.PI * 10 + 0.6) * 6
    )
  ),
}));
